module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[32]275.a5cfcc7.woff2";